// extracted by mini-css-extract-plugin
export default {"Slider":"slider__Slider__AhCu7","ProgressMarker":"slider__ProgressMarker__f2_MZ"};